// Rename ArticleListName to the name of the feature you are creating.

export const RenameArticleList = async () => {
  const wrappers: NodeListOf<HTMLDivElement> = document.querySelectorAll(
    '[data-vr-zone="List articles"]'
  );

  wrappers.forEach((wrapper, index) => {
    wrapper.setAttribute('data-vr-zone', `List articles ${index + 1}`);
  });
};
